module.exports = __webpack_public_path__ + "img/Medical.da8b0744.svg";